@if (page$ | async; as page) {
  <div class="container container-page">
    <app-breadcrumbs></app-breadcrumbs>
    <div class="page-title-wrapper">
      <h1 class="page-title">
        <span translate>{{ page.title }}</span>
      </h1>
    </div>
    <div class="page-content" [innerHTML]="page.content | safeHtml"></div>
  </div>
}
